import React, { Component } from "react";
import { Accordion, Menu } from "semantic-ui-react";
import SubLink from "./sublink";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import SideLink from "./sidelink";
import { dailyPlacementDashboard, FEATURES, isDumpAnalysisReportEnabled, isLRDumpReportEnabled, isLrProfitabilityReportEnabled, isMISReportEnabled, isReportsEnabled, isTripDistanceAnalysisReportEnabled, reportNames, reportTitle, sideBarOptionsHide, SOBReport } from "../../utils/constant";

class AccordionBillingMenu extends Component {
  state = { activeIndex: 0 };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { t } = this.props;
    const { activeIndex } = this.state;
    const customerNo = localStorage.getItem('customerNumber')

    const Masters = (
      <div className="p-0 m-0">
        {this.props.permissions.TA_VENDOR_MASTER &&
          this.props.permissions.TA_VENDOR_MASTER.VIEW == true ? (
          <SubLink subLink={t("Purchase Order")} To="/PurchaseOrder" />
        ) : null}

        {!sideBarOptionsHide ? (
          <SubLink
            Exact={true}
            To="/bill"
            subLink={t("bills")}
          />
        ) : null}
      </div>


    );

    return (
      <Accordion
        as={Menu}
        vertical
        style={{ backgroundColor: "#2D373C", width: "100%" }}
      >
        <Menu.Item className="mb-3 accordionStyle">
          <Accordion.Title
            className="w3-text-white w3-small"
            active={activeIndex === 1}
            content={
              <div className="nav-link p-hover p-3 w3-text-white checklink stylefont">
                <img
                  className="ml-2"
                  src="assets/svg/Billing Platform.svg"
                  alt="Masters"
                  width="18"
                />
                <span>&nbsp;&nbsp;&nbsp;&nbsp;{t("Billing Platform")}</span>
              </div>
            }
            index={1}
            onClick={this.handleClick}
          />
          <Accordion.Content active={activeIndex === 1} content={Masters} />
        </Menu.Item>
      </Accordion>
    );
  }
}
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  };
};
export default connect(mapStateToProps)(
  translate("sidebar")(AccordionBillingMenu)
);
